import CHILD_ROUTE from './child-route';

export const REGION_ROUTE_UID = {
  AUVERGNE: 'auvergne-rhone-alpes',
  BOURGOGNE: 'bourgogne-franche-comte',
  BRETAGNE: 'bretagne',
  CENTRE: 'centre-val-de-loire',
  CORSE: 'corse',
  DOM: 'dom',
  GRAND_EST: 'grand-est',
  HAUTS_DE_FRANCE: 'hauts-de-france',
  ILE_DE_FRANCE: 'ile-de-france',
  NATIONAL: 'national',
  NORMANDIE: 'normandie',
  NOUVELLE_AQUITAINE: 'nouvelle-aquitaine',
  OCCITANIE: 'occitanie',
  PACA: 'paca',
  PAYS_DE_LA_LOIRE: 'pays-de-la-loire',
  INTERNATIONAL: 'international',
};

/**
 * List of absolute routes
 */

const routes = [
  {
    id: 'HOME',
    fr: '',
    en: '',
    fileLoader: /* istanbul ignore next */ () => import('../../pages/Home'),
  },
  {
    id: 'HOME_REGION',
    fr: `:regionSlug(${Object.values(REGION_ROUTE_UID).join('|')})`,
    en: `:regionSlug(${Object.values(REGION_ROUTE_UID).join('|')})`,
    fileLoader: /* istanbul ignore next */ () => import('../../pages/Home'),
  },
  {
    id: 'NEWSROOM',
    fr: 'espace-presse',
    en: 'newsroom',
    fileLoader: /* istanbul ignore next */ () => import('../../pages/Newsroom'),
    children: [
      {
        ...CHILD_ROUTE.PRESS_RELEASE,
        fileLoader: /* istanbul ignore next */ () =>
          import('../../containers/PopOver/MediaPressReleasePopOverWithList'),
      },
    ],
  },
  {
    id: 'HUB_ACTU',
    fr: 'hub-actus',
    en: 'news-hub',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/HubActualites'),
  },
  {
    id: 'HUB_NEWSROOM',
    fr: 'hub-communiques-de-presse',
    en: 'press-releases',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/HubNewsroom'),
  },
  {
    id: 'RSE',
    fr: 'nos-actions-pour-lenvironnement',
    en: 'what-we-do-for-the-environment',
    fileLoader: /* istanbul ignore next */ () => import('../../pages/RSE'),
    children: [CHILD_ROUTE.RSE_POPIN],
  },
  {
    id: 'HOT_ARTICLE',
    fr: 'actualite/:articleUid',
    en: 'news/:articleUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/HotArticle'),
  },
  {
    id: 'SEARCH',
    fr: 'recherche/:query?',
    en: 'search/:query?',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Search'),
  },
  {
    id: 'FINANCIAL_DEBT',
    fr: 'dette',
    en: 'financial-debt',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Debt'),
  },
  {
    id: 'FINANCIAL_RATING',
    fr: 'notations',
    en: 'financial-rating',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Rating'),
  },
  {
    id: 'FINANCIAL_PUBLICATION',
    fr: 'publications',
    en: 'financial-publication',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Publication'),
  },
  {
    id: 'FINANCIAL_PUBLICATION_YEAR',
    fr: 'publications/:year',
    en: 'financial-publication/:year',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Publication'),
    children: [
      {
        ...CHILD_ROUTE.MEDIA,
        fileLoader: /* istanbul ignore next */ () =>
          import('../../containers/PopOver/MediaPublicationPopOverWithList'),
      },
    ],
  },
  {
    id: 'FINANCIAL_PRESS_RELEASE',
    fr: 'communiques-de-presse',
    en: 'financial-press-release',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/PressRelease'),
  },
  {
    id: 'FINANCIAL_PRESS_RELEASE_YEAR',
    fr: 'communiques-de-presse/:year',
    en: 'financial-press-release/:year',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/PressRelease'),
    children: [
      {
        ...CHILD_ROUTE.PRESS_RELEASE,
        fileLoader: /* istanbul ignore next */ () =>
          import('../../containers/PopOver/MediaPressReleasePopOverWithList'),
      },
    ],
  },
  {
    id: 'FINANCIAL_KEY_FIGURES',
    fr: 'chiffres-cles',
    en: 'financial-key-figures',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/KeyFigures'),
  },
  {
    id: 'LA_POSTE_EN_4',
    fr: 'la-poste-se-plie-en-4',
    en: 'la-poste-se-plie-en-4',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/LaPosteEn4/LaPosteEn4'),
  },
  // important : this route must be the last of the list
  {
    id: 'COLD_ARTICLE',
    fr: ':articleUid',
    en: ':articleUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/ColdArticle'),
  },
];

export default routes;
